<template>
  <div>
    <label class="field_label">{{ current_champ.label }} {{ is_ffa ? " FFA" : "" }} {{ is_ffrp ? "FFRP" : "" }}<span
        class="text-red" v-if="current_champ.mandatory == 1">*</span></label>
    <v-text-field v-model="current_champ.value" ref="field" @blur="$refs.field.validate()"
      :disabled="current_champ.disabled || is_disable"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode, is_ffa, is_ffrp)]"></v-text-field>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      current_champ: {},
    };
  },
  computed: {
    ...mapStores(useMainStore),

    is_ffrp() {
      return this.mainStore.module.is_ffrp_event;
    },
    is_ffa() {
      if (!this.inscription.coureur.champs.type_document) {
        return false;
      }
      return this.inscription.coureur.champs.type_document.value == "Licence FFA";
    },
  },

  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },

    "inscription.coureur.champs.nom": {
      deep: true,
      async handler() {
        await this.fetch_ffa_webservice();
      },
    },
    "inscription.coureur.champs.prenom": {
      deep: true,
      async handler() {
        await this.fetch_ffa_webservice();
      },
    },
    "inscription.coureur.champs.sexe": {
      deep: true,
      async handler() {
        await this.fetch_ffa_webservice();
      },
    },
    "inscription.coureur.champs.date_naissance": {
      deep: true,
      async handler() {
        await this.fetch_ffa_webservice();
      },
    },
  },
  methods: {
    async fetch_ffa_webservice() {
      this.inscription.coureur.unvalidate_document();
      let disable_webservice = this.mainStore.module.disable_webservice_ffa;
      let num_ffa = this.mainStore.module.ffa_num_competition;
      if (disable_webservice || !num_ffa || num_ffa == "") {
        return;
      }
      await this.inscription.coureur.try_fetch_ffa_webservice(num_ffa);
    },
  },
  created() {
    this.current_champ = this.champ;
  },
};
</script>

<style lang="scss" scoped></style>